import { checkActionAttribute } from "./checkActionAttribute";

import { Employee } from "../../CRUDs/entities/Employee";

export const employeesModalActionsListners = (target, actionsWindow) => {

    const employeeId = target.parent().data('id');
    const isAdmin = parseInt(target.parent().data('is_admin'));
    const employeeStatus = parseInt(target.parent().data('employee_status'));
    const employee = new Employee(employeeId);

    actionsWindow.find('.action').off();

    if (isAdmin) {
        actionsWindow.find('.action.delete').addClass('d-none',true)
        actionsWindow.find('.action.deactive').addClass('d-none',true)
        actionsWindow.find('.action.show-jobs-map').addClass('d-none')
    }
    else {
        actionsWindow.find('.action.delete').removeClass('d-none')
        actionsWindow.find('.action.deactive').removeClass('d-none')
        actionsWindow.find('.action.show-jobs-map').removeClass('d-none')
    }
    // changing text
    employeeStatus ? actionsWindow.find('.action.deactive').text('Deactive')
            : actionsWindow.find('.action.deactive').text('Activate')

    // call
    actionsWindow.find('.action.call').on('click', function(e) {
        location.href = '/cockpit/phone-'+target.parents('.data-row').children('td.phone-number').text();
    });

    // email
    actionsWindow.find('.action.email').on('click', function(e) {
        location.href = '/cockpit/email-'+target.parents('.data-row').next().find('.employee-email').text().trim();
    });

    // edit employee
    actionsWindow.find('.action.edit').on('click', (e) => {
        employee.openModal('edit');
    });

    // delete employee
    actionsWindow.find('.action.delete').on('click', (e) => {
        employee.deleteEmployee(employeeId);
    });

    // deactive/activate employee
    actionsWindow.find('.action.deactive').on('click', (e) => {
        employee.changeEmployeeStatus(employeeId, employeeStatus);
    });

    actionsWindow.find('.action.show-jobs-map').on('click', e => {
        employee.showJobsMap(employeeId)
    })
    

}
